module.exports = __webpack_public_path__ + "static/media/strategy.b1e7fb25.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/estrategas/tools/strategy.png
// module id = 614
// module chunks = 0